import { ActionTypeIds } from "../ActionTypeIds";

export const ActionConfigAutoSubmit = {
  actions: {
    [ActionTypeIds.SwitchAutoBidding]: {
      enabled: true
    }
  }
};
